import { render, staticRenderFns } from "./LongtermMedication.vue?vue&type=template&id=0eb6ef94&"
import script from "./LongtermMedication.vue?vue&type=script&lang=js&"
export * from "./LongtermMedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports